import styled from 'styled-components';

export const SCardContainer = styled.div`
  padding: 24px 32px;
  background: #ffffff;
  box-shadow: 2px 4px 12px 0px rgba(24, 42, 51, 0.12);
  border-radius: 8px;
`;
